module.exports = __webpack_public_path__ + "static/media/radar.f75a48e3.svg";